var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Logger } from "./components/logger";
var defaults = new Logger({});
/**
 * @protected
 */
var LoggerContext = React.createContext(defaults);
/**
 * Provider component for supplying your application logger object to your React tree.
 * This data can be read with the `useLogger()` hook in your function components.
 */
export var LoggerProvider = function (props) {
    var logger = props.logger, children = props.children;
    var value = logger ? new Logger(logger) : defaults;
    return React.createElement(LoggerContext.Provider, { value: value }, children || null);
};
LoggerProvider.displayName = 'LoggerProvider';
/**
 * @deprecated
 * React hook for reading the values in the nearest parent `LoggerProvider` in your tree.
 *
 * @returns {Logger} an object contains the an Object of the interface Logger.
 *
 * @example
 * const MyComponent: React.FunctionComponent<{}> = () => {
 *   const { error, event } = useLogger();
 *
 *   error('My error level event)
 *
 *   const myErrorEvent = new SystemEvent(SystemEventLevel.CRITICAL, 'My custom level event')
 *   event(myErrorEvent);
 *
 *   .....
 *   ...
 * }
 */
export var useLogger = function () {
    return React.useContext(LoggerContext);
};
/**
 * React hook for reading the values in the nearest parent `LoggerProvider` in your tree.
 *
 * @returns {Logger} an object contains the an Object of the interface Logger.
 *
 * @example
 * const LogEvents = {
 *   TESTING_NO_TYPE: new SystemEvent(SystemEventLevel.WARN, 'TESTING_NO_TYPE'),
 *   TESTING_MULTI_FIELD_TYPE: new SystemEvent<{ bananas: number; apples: number; }>(SystemEventLevel.ERROR, 'TESTING_MULTI_FIELD_TYPE'),
 * }
 *
 * const MyComponent: React.FunctionComponent<{}> = () => {
 *   const systemEvents = useLoggerEvents(LogEvents);
 *
 *   systemEvents.TESTING_NO_TYPE.log({});
 *   systemEvents.TESTING_NO_TYPE.log({ foo: true });
 *   systemEvents.TESTING_MULTI_FIELD_TYPE.log({ bananas: 4, apples: 7 });
 *
 *   .....
 *   ...
 * }
 */
export function useLoggerEvents(systemEvents) {
    var logger = React.useContext(LoggerContext);
    return Object.keys(systemEvents).reduce(function (obj, key) {
        var _a;
        return __assign(__assign({}, obj), (_a = {}, _a[key] = { log: function (payload) {
                if (payload === void 0) { payload = {}; }
                return logger.event(systemEvents[key], { payload: payload });
            } }, _a));
    }, {});
}
//# sourceMappingURL=logger-context.js.map